import React, { useState } from "react";
import axiosClient from "utils/axios";

const useAxios = () => {
  // states
  const [loading, setLoading] = useState(false);
  const [_data, setData] = useState(null);
  const [error, setError] = useState(null);

  // functions
  const post = (url, data) => {
    setLoading(true);
    axiosClient
      .post(url, data)
      .then((d) => {
        setData(d);
      })
      .catch((err) => setError(err))
      .finally((f) => setLoading(false));
  };

  const put = (url, data) => {
    setLoading(true);
    axiosClient
      .put(url, data)
      .then((d) => {
        setData(d);
      })
      .catch((err) => setError(err))
      .finally((f) => setLoading(false));
  };

  const remove = (url) => {
    setLoading(true);
    axiosClient
      .delete(url)
      .then((d) => {
        setData(d);
      })
      .catch((err) => setError(err))
      .finally((f) => setLoading(false));
  };

  return { loading, data: _data, error, post, put, remove };
};

export default useAxios;
